import hideFaq from './components/builder';
import bigSearch from './components/header';

export default () => {
    hideFaq();
    bigSearch();

    const menuMobile = document.querySelector(".header-mobile-menu-open");
    const block = document.querySelector(".header-right");
    menuMobile.addEventListener("click", (e) => {
        e.preventDefault();
        block.classList.toggle("show");
    });


    let commonRegionSelects = document.getElementById('regionSelectCommon');
    let headerRegionSelects = document.getElementById('regionSelectHeader');

    commonRegionSelects ? commonSearchJobForms(commonRegionSelects, 'data-region-common') : false;
    headerRegionSelects ? commonSearchJobForms(headerRegionSelects, 'data-region-header') : false;


    function commonSearchJobForms(commonRegionSelects, dataAttr) {
        commonRegionSelects.addEventListener('change', function (e) {
            let target = e.target;
            let currentVal = target.value;
            showCities(currentVal, dataAttr);
        });

        function showCities(currentVal, dataAttr) {
            let options = document.querySelectorAll(`[${dataAttr}]`);
            options.forEach((item) => {
                let currentAttr = item.getAttribute(`${dataAttr}`);
                item.classList.remove('show');
                if (currentAttr === currentVal) {
                    item.classList.add('show');
                }
            });
        }
    }

    function customTwitterBlockInject(){
        let customTwitterBlock = document.getElementById('customTwitterBlock');
        let tweetsWrap = document.querySelector('#twitter .ctf-tweets');
        if(customTwitterBlock && tweetsWrap){
            let cloneBlock = customTwitterBlock.cloneNode(true);
            tweetsWrap.prepend(cloneBlock);
            cloneBlock.style.display = 'block';
        }
    }

    customTwitterBlockInject();

}
